import React from 'react';
import {
    withStyles, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = theme => ({
    root: {
        marginTop: 24,
        paddingRight : 20,
        paddingLeft : 20,
    },
    text: {
        fontFamily : "'Poppins', sans-serif",
        fontSize : 16,
    }
});

/**
 * Componente para la desripción del proyecto de la landing page
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const ObjectiveProject = ({ classes }) => {
    return (
        <div className={classes.root}>
            <Typography className={classes.text} align="justify">
                Esta herramienta interactiva te permite visualizar, explorar y analizar patrones espaciales de eventos de salud pública y de exposiciones demográficas, socio-económicas y medio-ambientales que tengan relevancia en el nivel local para la formulación de políticas, programas y prácticas orientadas a reducir las inequidades geográficas en salud.  
                Así mismo, te permite conocer los avances de Colombia en el cumplimiento de las metas  de los Objetivos de Desarrollo Sostenible relacionados con el Objetivo 3 
                -Salud y Bienestar a escalas geográficas subnacionales, y con ello monitorear el progreso en su compromiso de “No dejar a nadie atrás”.
            </Typography>
        </div>
    );
};

ObjectiveProject.propTypes = {
    classes : PropTypes.object,
}

export default withStyles(styles)(ObjectiveProject);


// WEBPACK FOOTER //
// ./src/components/landing-page/objectiveProject.js